<template>
    <b-badge @click="$emit('click')" href="#" class="ml-2 text-center font-weight-normal text-dark font-size-14 mr-2 " 
        style="border: 1px solid #ddd;" variant="light">

        

        {{this.title}} {{this.value}}
        <img  alt="" width="20px" class="" src="../assets/icons/fi-rr-cross-small.svg" style="cursor: pointer; "  />  


    </b-badge> 
</template>
<script>
export default {
    name: "FilterBadge",
    props: {
        title: {
          type: String
        },

        value: {
          type: String
        },
    },
    data() {
        return {
            
        };
    },
    computed: {
        
    },
    methods: {
    },
};
</script>
  
<style scoped>

</style>
